import {
  Container,
  Box,
  Grid,
  Button,
  Typography,
  Card,
  CardContent,
  Paper,
  Chip,
} from "@mui/material";
import React, { useRef, useContext, useEffect, useState } from "react";
import TextfieldWrapper from "../components/TextFields/TextField";
import SubmitButtonWrapper from "../components/TextFields/SubmitBtn";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import TextBoxWrapper from "../components/TextFields/TextBox";
import emailjs from "@emailjs/browser";
import { AnimatePresence, motion, useAnimation } from "framer-motion";
import Check from "../components/TextFields/Check";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import Social from "./Social";
import LoaderContext from "../components/LoaderContext";
import {
  Email,
  Phone,
  LocationOn,
  Send,
  CheckCircle,
  ContactMail,
  Message,
  Person,
} from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  subTitle: {
    fontSize: "30px",
    [theme.breakpoints.down("md")]: {
      fontSize: "25px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "29px",
    },
  },
  contactCard: {
    background: "linear-gradient(135deg, #1a1a2e, #16213e)",
    border: "1px solid rgba(255, 181, 16, 0.2)",
    borderRadius: "25px",
    backdropFilter: "blur(10px)",
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
  },
  infoCard: {
    background:
      "linear-gradient(135deg, rgba(255, 181, 16, 0.1), rgba(255, 107, 53, 0.1))",
    border: "1px solid rgba(255, 181, 16, 0.3)",
    borderRadius: "20px",
    backdropFilter: "blur(10px)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 15px 30px rgba(255, 181, 16, 0.2)",
    },
  },
  formField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "15px",
      transition: "all 0.3s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 5px 15px rgba(255, 181, 16, 0.2)",
      },
      "&.Mui-focused": {
        transform: "translateY(-2px)",
        boxShadow: "0 8px 25px rgba(255, 181, 16, 0.3)",
      },
    },
  },
}));

const Contact = () => {
  const controls = useAnimation();
  const classes = useStyles();
  const { isLoading } = useContext(LoaderContext);
  const [sending, setSending] = useState(false);
  const [sendEmailSuccess, setSendEmailSuccess] = useState(false);
  const [hoveredField, setHoveredField] = useState(null);

  const contactInfo = [
    {
      icon: <Email sx={{ fontSize: 30, color: "#ffb510" }} />,
      title: "Email",
      value: "m.humailsaleem@gmail.com",
      link: "mailto:m.humailsaleem@gmail.com",
    },
    {
      icon: <LocationOn sx={{ fontSize: 30, color: "#ffb510" }} />,
      title: "Location",
      value: "Karachi, Pakistan",
      link: "#",
    },
  ];

  useEffect(() => {
    if (!isLoading) {
      controls.start((i) => ({
        y: 0,
        opacity: 1,
        transition: { delay: i * 0.1 + 0.5 },
      }));
    } else {
      controls.start({ opacity: 0, y: 20 });
    }
  }, [isLoading, controls]);

  const initialFormState = {
    user_email: "",
    user_name: "",
    message: "",
  };

  const formValidation = Yup.object().shape({
    user_name: Yup.string()
      .max(25, "*Must be 25 characters or less")
      .required("*Required"),
    user_email: Yup.string()
      .email("Invalid email address")
      .required("*Required"),
    message: Yup.string()
      .min(10, "*Minimum 10 characters")
      .required("*Required"),
  });

  const form = useRef();

  const sendEmail = (values) => {
    setSending(true);
    emailjs
      .send("service_6f9kgre", "template_gtj8a6n", values, "eqLDTcvgYbpD8z6jv")
      .then(
        (result) => {
          console.log(result.text);
          setSendEmailSuccess(true);
          setSending(false);
        },
        (error) => {
          setSending(false);
          console.log(error.text);
        }
      );
  };

  return (
    <React.Fragment>
      <Container
        maxWidth="lg"
        sx={{
          minHeight: "100vh",
          px: { xs: 1, sm: 2, md: 2 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: { xs: 3, lg: 3 },
            width: "100%",
            maxWidth: "100%",
          }}
        >
          {/* Contact Information Section */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            style={{ flex: "0 0 auto" }}
          >
            <Card
              className={classes.contactCard}
              sx={{
                p: 2,
                width: "320px",
                flexShrink: 0,
                display: { xs: "none", xl: "block" },
              }}
            >
              <CardContent>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5, duration: 0.6 }}
                  style={{ textAlign: "center", marginBottom: "1rem" }}
                >
                  <ContactMail sx={{ fontSize: 60, color: "#ffb510", mb: 2 }} />
                  <Typography
                    variant="h3"
                    sx={{
                      color: "#ffb510",
                      fontWeight: "bold",
                      mb: 1,
                      background: "linear-gradient(45deg, #ffb510, #ff6b35)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Get In Touch
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#fff",
                      opacity: 0.9,
                      fontWeight: 300,
                      lineHeight: 1.6,
                    }}
                  >
                    Let's discuss your next project and bring your ideas to
                    life!
                  </Typography>
                </motion.div>

                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
                >
                  {contactInfo.map((info, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: -30 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.7 + index * 0.1, duration: 0.6 }}
                    >
                      <Paper
                        className={classes.infoCard}
                        sx={{
                          p: 2,
                          cursor: info.link !== "#" ? "pointer" : "default",
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                        onClick={() =>
                          info.link !== "#" && window.open(info.link)
                        }
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        {info.icon}
                        <Box>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              color: "#ffb510",
                              fontWeight: "bold",
                              mb: 0.5,
                            }}
                          >
                            {info.title}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ color: "#fff", opacity: 0.9 }}
                          >
                            {info.value}
                          </Typography>
                        </Box>
                      </Paper>
                    </motion.div>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </motion.div>

          {/* Contact Form Section */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            style={{ minWidth: 0, width: "100%" }}
          >
            <Formik
              initialValues={{ ...initialFormState }}
              validationSchema={formValidation}
              onSubmit={(values, { resetForm }) => {
                sendEmail(values);
                resetForm({ values: "" });
              }}
            >
              <Form>
                <AnimatePresence>
                  {!sendEmailSuccess && (
                    <Card
                      className={classes.contactCard}
                      sx={{ p: 1.5, width: "100%" }}
                    >
                      <CardContent>
                        <motion.div
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: 0.7, duration: 0.6 }}
                          style={{ textAlign: "center", marginBottom: "1rem" }}
                        >
                          <Message
                            sx={{ fontSize: 50, color: "#ffb510", mb: 2 }}
                          />
                          <Typography
                            variant="h4"
                            sx={{
                              color: "#ffb510",
                              fontWeight: "bold",
                              mb: 1,
                            }}
                          >
                            Send a Message
                          </Typography>
                        </motion.div>

                        <Grid container>
                          {/* Name Field */}
                          <Grid item xs={12}>
                            <motion.div
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: 0.9, duration: 0.6 }}
                              onMouseEnter={() => setHoveredField("name")}
                              onMouseLeave={() => setHoveredField(null)}
                            >
                              <div className={classes.formField}>
                                <TextfieldWrapper
                                  label="Your Full Name"
                                  name="user_name"
                                  icon={<Person sx={{ color: "#ffb510" }} />}
                                />
                              </div>
                            </motion.div>
                          </Grid>

                          {/* Email Field */}
                          <Grid item xs={12}>
                            <motion.div
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: 1.1, duration: 0.6 }}
                              onMouseEnter={() => setHoveredField("email")}
                              onMouseLeave={() => setHoveredField(null)}
                            >
                              <div className={classes.formField}>
                                <TextfieldWrapper
                                  label="Your Email Address"
                                  name="user_email"
                                  icon={<Email sx={{ color: "#ffb510" }} />}
                                />
                              </div>
                            </motion.div>
                          </Grid>

                          {/* Message Field */}
                          <Grid item xs={12}>
                            <motion.div
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: 1.3, duration: 0.6 }}
                              onMouseEnter={() => setHoveredField("message")}
                              onMouseLeave={() => setHoveredField(null)}
                            >
                              <div className={classes.formField}>
                                <TextBoxWrapper
                                  label="Your Message"
                                  name="message"
                                />
                              </div>
                            </motion.div>
                          </Grid>

                          {/* Submit Button */}
                          <Grid item xs={12}>
                            <motion.div
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: 1.5, duration: 0.6 }}
                              style={{ marginTop: "0.5rem" }}
                            >
                              <motion.div
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                              >
                                <Button
                                  variant="contained"
                                  color="primary"
                                  startIcon={<Send />}
                                  disabled={sending}
                                  sx={{
                                    width: "100%",
                                    py: 1.5,
                                    fontSize: "1.1rem",
                                    fontWeight: "bold",
                                    borderRadius: "15px",
                                    background:
                                      "linear-gradient(45deg, #ffb510, #ff6b35)",
                                    "&:hover": {
                                      background:
                                        "linear-gradient(45deg, #ff6b35, #ffb510)",
                                      transform: "translateY(-2px)",
                                      boxShadow:
                                        "0 10px 25px rgba(255, 181, 16, 0.4)",
                                    },
                                    "&:disabled": {
                                      background: "rgba(255, 181, 16, 0.3)",
                                    },
                                    transition: "all 0.3s ease",
                                  }}
                                  onClick={() => {
                                    const form = document.querySelector("form");
                                    if (form) {
                                      form.requestSubmit();
                                    }
                                  }}
                                >
                                  {sending ? "Sending..." : "Send Message"}
                                </Button>
                              </motion.div>
                            </motion.div>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  )}
                </AnimatePresence>

                {/* Success Message */}
                <AnimatePresence>
                  {sendEmailSuccess && (
                    <motion.div
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.8 }}
                      transition={{ duration: 0.5 }}
                    >
                      <Card
                        className={classes.contactCard}
                        sx={{ p: 4, textAlign: "center" }}
                      >
                        <CardContent>
                          <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{
                              delay: 0.2,
                              duration: 0.6,
                              type: "spring",
                            }}
                          >
                            <CheckCircle
                              sx={{ fontSize: 80, color: "#4CAF50", mb: 2 }}
                            />
                          </motion.div>

                          <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4, duration: 0.6 }}
                          >
                            <Typography
                              variant="h4"
                              sx={{
                                color: "#4CAF50",
                                fontWeight: "bold",
                                mb: 2,
                              }}
                            >
                              Message Sent Successfully!
                            </Typography>

                            <Typography
                              variant="body1"
                              sx={{
                                color: "#fff",
                                opacity: 0.9,
                                mb: 3,
                                lineHeight: 1.6,
                              }}
                            >
                              Thank you for reaching out! I've received your
                              message and will get back to you as soon as
                              possible.
                            </Typography>

                            <motion.div
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: 0.6, duration: 0.6 }}
                            >
                              <Link to="/" style={{ textDecoration: "none" }}>
                                <Button
                                  variant="outlined"
                                  sx={{
                                    borderColor: "#ffb510",
                                    color: "#ffb510",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: "15px",
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                    "&:hover": {
                                      borderColor: "#ff6b35",
                                      backgroundColor:
                                        "rgba(255, 181, 16, 0.1)",
                                      transform: "translateY(-2px)",
                                    },
                                    transition: "all 0.3s ease",
                                  }}
                                >
                                  Back to Homepage
                                </Button>
                              </Link>
                            </motion.div>
                          </motion.div>
                        </CardContent>
                      </Card>
                    </motion.div>
                  )}
                </AnimatePresence>
              </Form>
            </Formik>
          </motion.div>
        </Box>
      </Container>

      <Social />
    </React.Fragment>
  );
};

export default Contact;
